// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "trix"
import "@rails/actiontext"

import {Turbo} from "@hotwired/turbo-rails"

// turbo_stream.advanced_redirect(whatever_path)
Turbo.StreamActions.advanced_redirect = function() {
  let url = this.getAttribute('url')
  Turbo.visit(url)
}
